import axios from 'axios';
import foreignService from '../../../core/services/Market/MoneyFlow/ForeignService';
import proprietaryService from '../../../core/services/Market/MoneyFlow/ProprietaryService';
import reducerRegistry from '../../helpers/ReducerRegistry';
import Const from './Const';
import ConstCommon from './../../common/Const';
import currentState from './../../helpers/CurrentState';

export const REDUCER_NAME = 'MONEY_FLOW';

const FETCH_PROPRIETARY_SUCCESS = `${REDUCER_NAME}_FETCH_PROPRIETARY_SUCCESS`;
const SET_PROPRIETARY_LOADING = `${REDUCER_NAME}_SET_PROPRIETARY_LOADING`;

const FETCH_FOREIGN_SUCCESS = `${REDUCER_NAME}_FETCH_FOREIGN_SUCCESS`;
const SET_FOREIGN_LOADING = `${REDUCER_NAME}_SET_FOREIGN_LOADING`;

const CHANGE_COM_GROUP_CODE_PROPRIETARY = `${REDUCER_NAME}CHANGE_COM_GROUP_CODE_PROPRIETARY`;

const CHANGE_FOREIGN_CURRENT_SEARCH = `${REDUCER_NAME}CHANGE_FOREIGN_CURRENT_SEARCH`;

const CHANGE_SIZE_COMPONENT = `${REDUCER_NAME}CHANGE_SIZE_COMPONENT`;

const SET_REALTIME_DATA = `${REDUCER_NAME}SET_REALTIME_DATA`;
const INIT_COMPONENT = `${REDUCER_NAME}INIT_COMPONENT`;
const UNMOUNT_COMPONENT = `${REDUCER_NAME}UNMOUNT_COMPONENT`;

export const setRealtimeData = data => ({
  type: SET_REALTIME_DATA,
  payload: data,
});

const setProprietaryLoading = (payload = true) => ({
  type: SET_PROPRIETARY_LOADING,
  payload,
});

export const fetchProprietary = payload => dispatch => {
  const source = axios.CancelToken.source();
  dispatch(setProprietaryLoading());
  proprietaryService
    .getProprietary(payload, source)
    .then(response => {
      if (!response) {
        dispatch(setProprietaryLoading(false));
        return;
      }
      dispatch(
        fetchProprietarySuccess({
          data: response.items ? response.items[0] : [],
        }),
      );
    })
    .catch(error => dispatch(setProprietaryLoading(false)));

  return source;
};

export const fetchProprietarySuccess = ({ data }) => ({
  type: FETCH_PROPRIETARY_SUCCESS,
  payload: data,
});

const setForeignLoading = (payload = true) => ({
  type: SET_FOREIGN_LOADING,
  payload,
});

export const fetchForeign = payload => dispatch => {
  const source = axios.CancelToken.source();
  dispatch(setForeignLoading());
  foreignService
    .getForeign(payload, source)
    .then(response => {
      if (!response) {
        dispatch(setForeignLoading(false));
        return;
      }
      dispatch(
        fetchForeignSuccess({
          data: response.items ? response.items[0] : [],
        }),
      );
    })
    .catch(error => dispatch(setForeignLoading(false)));

  return source;
};

export const fetchForeignSuccess = ({ data }) => ({
  type: FETCH_FOREIGN_SUCCESS,
  payload: data,
});

export const changeForeignCurrentSearch = currentSearch => {
  return dispatch => {
    currentState.add(
      ConstCommon.listComponent.MoneyFlow,
      'foreign.currentSearch',
      currentSearch,
    );
    dispatch({
      type: CHANGE_FOREIGN_CURRENT_SEARCH,
      payload: {
        currentSearch,
      },
    });
  };
};

export function changeComGroupCodeProprietary(comGroupCode) {
  return (dispatch, getState) => {
    const currentComGroupCode = getState()[REDUCER_NAME].comGroupCode;
    if (comGroupCode !== currentComGroupCode) {
      currentState.add(
        ConstCommon.listComponent.MoneyFlow,
        'proprietary.comGroupCode',
        comGroupCode,
      );
      dispatch({
        type: CHANGE_COM_GROUP_CODE_PROPRIETARY,
        payload: {
          comGroupCode,
        },
      });
    }
  };
}

const initialState = {};

const defaultCurrentSearch = {
  code: 'VNINDEX',
  displayCode: 'VNINDEX',
};

const reducer = (state = {}, action) => {
  switch (action.type) {
    case INIT_COMPONENT:
      return {
        ...state,
        ...initialState,
        proprietary: {
          ...state.proprietary,
          isLoading: true,
          data: {},
          comGroupCode:
            currentState.get(
              ConstCommon.listComponent.MoneyFlow,
              'proprietary.comGroupCode',
            ) || Const.listFilterByOrganCode.VNINDEX.key,
        },
        foreign: {
          ...state.foreign,
          isLoading: true,
          data: {},
          currentSearch:
            currentState.get(
              ConstCommon.listComponent.MoneyFlow,
              'foreign.currentSearch',
            ) || defaultCurrentSearch,
          comGroupCode:
            currentState.get(
              ConstCommon.listComponent.MoneyFlow,
              'foreign.comGroupCode',
            ) || Const.listFilterByOrganCode.VNINDEX.key,
        },
        realtimeData: {},
      };

    case UNMOUNT_COMPONENT:
      return {};

    case FETCH_PROPRIETARY_SUCCESS:
      return {
        ...state,
        proprietary: {
          ...state.proprietary,
          data: action.payload,
          isLoading: false,
        },
      };

    case SET_PROPRIETARY_LOADING:
      return {
        ...state,
        proprietary: {
          ...state.proprietary,
          isLoading: action.payload,
        },
      };
    case FETCH_FOREIGN_SUCCESS:
      return {
        ...state,
        foreign: {
          ...state.foreign,
          data: action.payload,
          isLoading: false,
        },
      };

    case SET_FOREIGN_LOADING:
      return {
        ...state,
        foreign: {
          ...state.foreign,
          isLoading: action.payload,
        },
      };

    case CHANGE_FOREIGN_CURRENT_SEARCH:
      return {
        ...state,
        foreign: {
          ...state.foreign,
          ...action.payload,
        },
      };

    case CHANGE_COM_GROUP_CODE_PROPRIETARY:
      return {
        ...state,
        proprietary: {
          ...state.proprietary,
          ...action.payload,
        },
      };

    case CHANGE_SIZE_COMPONENT:
      return {
        ...state,
        component: action.payload,
      };

    case SET_REALTIME_DATA:
      const realtimeData = action.payload.reduce((data, ticker) => {
        return {
          [ticker.organCode]: ticker,
          ...data,
        };
      }, {});

      return {
        ...state,
        realtimeData,
      };

    default:
      return state;
  }
};

reducerRegistry.register(REDUCER_NAME, reducer);
